// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Icd10CodeOption-module__font-s-10___JUrBD {
  font-size: 10px !important;
}

.Icd10CodeOption-module__font-s-12___bYNL1 {
  font-size: 12px !important;
}

.Icd10CodeOption-module__font-s-13___aId89 {
  font-size: 13px !important;
}

.Icd10CodeOption-module__font-s-14___BXVri {
  font-size: 14px !important;
}

.Icd10CodeOption-module__font-s-15___R6xzz {
  font-size: 15px !important;
}

.Icd10CodeOption-module__font-s-16___JJB2l {
  font-size: 16px !important;
}

.Icd10CodeOption-module__font-s-18___yCBls {
  font-size: 18px !important;
}

.Icd10CodeOption-module__font-s-20___NIoXI {
  font-size: 20px !important;
}

.Icd10CodeOption-module__font-s-22___tB2o7 {
  font-size: 22px !important;
}

.Icd10CodeOption-module__font-s-28___cR6_2 {
  font-size: 28px !important;
}

.Icd10CodeOption-module__font-w-400___wmrW0 {
  font-weight: 400 !important;
}

.Icd10CodeOption-module__font-w-500___s4X4M {
  font-weight: 500 !important;
}

.Icd10CodeOption-module__font-w-600____KTA0 {
  font-weight: 600 !important;
}

.Icd10CodeOption-module__font-w-700___Gu3tH {
  font-weight: 700 !important;
}

.Icd10CodeOption-module__p-5___vlrMI {
  padding: 5px !important;
}

.Icd10CodeOption-module__p-12___ajtmu {
  padding: 12px !important;
}

.Icd10CodeOption-module__p-16___zO5i_ {
  padding: 16px !important;
}

.Icd10CodeOption-module__p-30___rFq2_ {
  padding: 30px !important;
}

.Icd10CodeOption-module__p-b-0___DpCME {
  padding-bottom: 0 !important;
}

.Icd10CodeOption-module__p-b-5___sslRN {
  padding-bottom: 5px !important;
}

.Icd10CodeOption-module__p-b-10___MOcb9 {
  padding-bottom: 10px !important;
}

.Icd10CodeOption-module__p-b-12___rV3XK {
  padding-bottom: 12px !important;
}

.Icd10CodeOption-module__p-b-16___Bkzfr {
  padding-bottom: 16px !important;
}

.Icd10CodeOption-module__p-b-18___vwDhu {
  padding-bottom: 18px !important;
}

.Icd10CodeOption-module__p-b-20___KphsW {
  padding-bottom: 20px !important;
}

.Icd10CodeOption-module__p-b-25___GXR_o {
  padding-bottom: 25px !important;
}

.Icd10CodeOption-module__p-b-30___C7Hba {
  padding-bottom: 30px !important;
}

.Icd10CodeOption-module__p-b-50___jZdPI {
  padding-bottom: 50px !important;
}

.Icd10CodeOption-module__p-t-0___Xc3HI {
  padding-top: 0 !important;
}

.Icd10CodeOption-module__p-t-12___Xoibm {
  padding-top: 12px !important;
}

.Icd10CodeOption-module__p-t-16___L1CEf {
  padding-top: 16px !important;
}

.Icd10CodeOption-module__p-t-18___c_4yh {
  padding-top: 18px !important;
}

.Icd10CodeOption-module__p-t-20___AB2hF {
  padding-top: 20px !important;
}

.Icd10CodeOption-module__p-t-30___pHPsb {
  padding-top: 30px !important;
}

.Icd10CodeOption-module__p-t-40___yS528 {
  padding-top: 40px !important;
}

.Icd10CodeOption-module__p-t-50___prrXV {
  padding-top: 50px !important;
}

.Icd10CodeOption-module__p-l-20___ZZA3N {
  padding-left: 20px !important;
}

.Icd10CodeOption-module__p-l-30___dCbxe {
  padding-left: 30px !important;
}

.Icd10CodeOption-module__p-l-40___iZz0B {
  padding-left: 40px !important;
}

.Icd10CodeOption-module__p-r-16___Wk4WK {
  padding-right: 16px !important;
}

.Icd10CodeOption-module__p-r-20___igWcj {
  padding-right: 20px !important;
}

.Icd10CodeOption-module__p-r-30___zFL4E {
  padding-right: 30px !important;
}

.Icd10CodeOption-module__p-r-50___YvTa6 {
  padding-right: 50px !important;
}

.Icd10CodeOption-module__p-r-60___fvlsn {
  padding-right: 60px !important;
}

.Icd10CodeOption-module__m-b-1___rIWzy {
  margin-bottom: 1px !important;
}

.Icd10CodeOption-module__m-b-2___I6GzI {
  margin-bottom: 2px !important;
}

.Icd10CodeOption-module__m-b-6___QBGsC {
  margin-bottom: 6px !important;
}

.Icd10CodeOption-module__m-b-8___VpG1D {
  margin-bottom: 8px !important;
}

.Icd10CodeOption-module__m-b-10___Le8Md {
  margin-bottom: 10px !important;
}

.Icd10CodeOption-module__m-b-14___EUp7X {
  margin-bottom: 14px !important;
}

.Icd10CodeOption-module__m-b-16___YAqrA {
  margin-bottom: 16px !important;
}

.Icd10CodeOption-module__m-b-20___eb8vG {
  margin-bottom: 20px !important;
}

.Icd10CodeOption-module__m-b-22___zkeJR {
  margin-bottom: 22px !important;
}

.Icd10CodeOption-module__m-b-24___EhnIQ {
  margin-bottom: 24px !important;
}

.Icd10CodeOption-module__m-b-30___cwLEk {
  margin-bottom: 30px !important;
}

.Icd10CodeOption-module__m-b-32___sfBJb {
  margin-bottom: 32px !important;
}

.Icd10CodeOption-module__m-b-40___WktiP {
  margin-bottom: 40px !important;
}

.Icd10CodeOption-module__m-t-2___xAjtF {
  margin-top: 2px !important;
}

.Icd10CodeOption-module__m-t-3___bGsNR {
  margin-top: 3px !important;
}

.Icd10CodeOption-module__m-t-4___ML1O7 {
  margin-top: 4px !important;
}

.Icd10CodeOption-module__m-t-5___HimpH {
  margin-top: 5px !important;
}

.Icd10CodeOption-module__m-t-8___Suteq {
  margin-top: 8px !important;
}

.Icd10CodeOption-module__m-t-10___ieaEy {
  margin-top: 10px !important;
}

.Icd10CodeOption-module__m-t-15___KUCul {
  margin-top: 15px !important;
}

.Icd10CodeOption-module__m-t-16___YqY7g {
  margin-top: 16px !important;
}

.Icd10CodeOption-module__m-t-20___UdBOW {
  margin-top: 20px !important;
}

.Icd10CodeOption-module__m-t-22___xwnMz {
  margin-top: 22px !important;
}

.Icd10CodeOption-module__m-t-30___k45ku {
  margin-top: 30px !important;
}

.Icd10CodeOption-module__m-t-32___pEYJV {
  margin-top: 32px !important;
}

.Icd10CodeOption-module__m-l-auto___wUUW3 {
  margin-left: auto !important;
}

.Icd10CodeOption-module__m-l-4___s_a6k {
  margin-left: 4px !important;
}

.Icd10CodeOption-module__m-l-5___efmOr {
  margin-left: 5px !important;
}

.Icd10CodeOption-module__m-l-6___r5tOe {
  margin-left: 6px !important;
}

.Icd10CodeOption-module__m-l-8___j6F0n {
  margin-left: 8px !important;
}

.Icd10CodeOption-module__m-l-10___lDdz0 {
  margin-left: 10px !important;
}

.Icd10CodeOption-module__m-l-16___xhEdB {
  margin-left: 16px !important;
}

.Icd10CodeOption-module__m-l-20___zdwlF {
  margin-left: 20px !important;
}

.Icd10CodeOption-module__m-l-24___UHDgS {
  margin-left: 24px !important;
}

.Icd10CodeOption-module__m-l-30___xUPNn {
  margin-left: 30px !important;
}

.Icd10CodeOption-module__m-l-35___i8M1k {
  margin-left: 35px !important;
}

.Icd10CodeOption-module__m-l-40___Xx4nQ {
  margin-left: 40px !important;
}

.Icd10CodeOption-module__m-r-8___XekZy {
  margin-right: 8px !important;
}

.Icd10CodeOption-module__m-r-10___hJnfB {
  margin-right: 10px !important;
}

.Icd10CodeOption-module__m-r-16___GeG8x {
  margin-right: 16px !important;
}

.Icd10CodeOption-module__m-r-20___nsAx8 {
  margin-right: 20px !important;
}

.Icd10CodeOption-module__m-r-24___X6dfu {
  margin-right: 24px !important;
}

.Icd10CodeOption-module__m-r-30___hJyyr {
  margin-right: 30px !important;
}

.Icd10CodeOption-module__m-r-40___uOD7z {
  margin-right: 40px !important;
}

.Icd10CodeOption-module__border-r-3___ljjJM {
  border-radius: 3px !important;
}

.Icd10CodeOption-module__border-r-4___nOjrj {
  border-radius: 4px !important;
}

.Icd10CodeOption-module__border-r-6___nhBUA {
  border-radius: 6px !important;
}

.Icd10CodeOption-module__border-r-10___qFTxf {
  border-radius: 10px !important;
}

.Icd10CodeOption-module__border-r-12___ydqKc {
  border-radius: 12px !important;
}

.Icd10CodeOption-module__border-r-16___As5Pr {
  border-radius: 16px !important;
}

.Icd10CodeOption-module__border-r-50___IKDkf {
  border-radius: 50% !important;
}

.Icd10CodeOption-module__primary-border___NWuIi {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Icd10CodeOption-module__primary-border-b___PLmHS {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Icd10CodeOption-module__primary-border-t___sFXQf {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Icd10CodeOption-module__primary-border-l___nDGcD {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Icd10CodeOption-module__primary-border-r___MMIix {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Icd10CodeOption-module__secondary-border___ttelz {
  border: 1px solid #637768;
}

.Icd10CodeOption-module__secondary-border-b___bPLs8 {
  border-bottom: 1px solid #637768;
}

.Icd10CodeOption-module__secondary-border-t___OsskH {
  border-top: 1px solid #637768;
}

.Icd10CodeOption-module__secondary-border-l___LbMaf {
  border-left: 1px solid #637768;
}

.Icd10CodeOption-module__secondary-border-r___JImsU {
  border-right: 1px solid #637768;
}

.Icd10CodeOption-module__gap-0___J_nX9 {
  gap: 0 !important;
}

.Icd10CodeOption-module__gap-2___jwJGL {
  gap: 2px !important;
}

.Icd10CodeOption-module__gap-4___vkpPx {
  gap: 4px !important;
}

.Icd10CodeOption-module__gap-5___F76Wl {
  gap: 5px !important;
}

.Icd10CodeOption-module__gap-6___NZAvm {
  gap: 6px !important;
}

.Icd10CodeOption-module__gap-8___NmqwZ {
  gap: 8px !important;
}

.Icd10CodeOption-module__gap-10___GnzEt {
  gap: 10px !important;
}

.Icd10CodeOption-module__gap-12____RDiV {
  gap: 12px !important;
}

.Icd10CodeOption-module__gap-14___Bmx_M {
  gap: 14px !important;
}

.Icd10CodeOption-module__gap-16___xpiei {
  gap: 16px !important;
}

.Icd10CodeOption-module__gap-18___rDc6J {
  gap: 18px !important;
}

.Icd10CodeOption-module__gap-20___pZ1KU {
  gap: 20px !important;
}

.Icd10CodeOption-module__gap-24___K29GT {
  gap: 24px !important;
}

.Icd10CodeOption-module__gap-26___P3N3n {
  gap: 26px !important;
}

.Icd10CodeOption-module__gap-30___VnK7J {
  gap: 30px !important;
}

.Icd10CodeOption-module__gap-32___pNnUB {
  gap: 32px !important;
}

.Icd10CodeOption-module__gap-40___qDptb {
  gap: 40px !important;
}

.Icd10CodeOption-module__gap-50___qYxbQ {
  gap: 50px !important;
}

.Icd10CodeOption-module__flex-1___hpLR8 {
  flex: 1;
}

.Icd10CodeOption-module__flex-none___mCnoP {
  flex: none !important;
}

.Icd10CodeOption-module__flex-column___RuZzc {
  display: flex;
  flex-direction: column !important;
}

.Icd10CodeOption-module__flex-row___bIrQi {
  display: flex;
  flex-direction: row !important;
}

.Icd10CodeOption-module__vertically-centered___KvdV3 {
  display: flex;
  align-items: center !important;
}

.Icd10CodeOption-module__horizontally-centered___o8rfk {
  display: flex;
  justify-content: center !important;
}

.Icd10CodeOption-module__horizontally-end___YDHHJ {
  display: flex;
  justify-content: end !important;
}

.Icd10CodeOption-module__vertically-start___enxeL {
  display: flex;
  align-items: start !important;
}

.Icd10CodeOption-module__space-between___i8Jto {
  display: flex;
  justify-content: space-between !important;
}

.Icd10CodeOption-module__flex-wrap___RB9H7 {
  flex-wrap: wrap !important;
}

.Icd10CodeOption-module__height-100___conIS {
  height: 100%;
}

.Icd10CodeOption-module__width-50___gveZR {
  width: 50% !important;
}

.Icd10CodeOption-module__width-100___L4zbS {
  width: 100%;
}

.Icd10CodeOption-module__cursor-pointer___sTS81 {
  cursor: pointer;
}

.Icd10CodeOption-module__cursor-not-allowed___IioSS {
  cursor: not-allowed !important;
}

.Icd10CodeOption-module__absolute-centered___vO_qg {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Icd10CodeOption-module__absolute___mRpcQ {
  position: absolute;
}

.Icd10CodeOption-module__relative___Z2do3 {
  position: relative;
}

.Icd10CodeOption-module__fixed___levTj {
  position: fixed;
}

.Icd10CodeOption-module__visible___mCR8O {
  opacity: 1;
}

.Icd10CodeOption-module__invisible___v3iQj {
  opacity: 0;
}

.Icd10CodeOption-module__col-90___HINB9 {
  width: 90% !important;
}

.Icd10CodeOption-module__col-auto___uG_nM {
  width: auto !important;
}

.Icd10CodeOption-module__medical-tabs___GTm8L {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Icd10CodeOption-module__medical-table-new___yCO_v {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Icd10CodeOption-module__medical-table-new___yCO_v:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Icd10CodeOption-module__medical-table-new___yCO_v::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Icd10CodeOption-module__medical-table-new___yCO_v::-webkit-scrollbar-track {
  display: none;
}
.Icd10CodeOption-module__medical-table-new___yCO_v.Icd10CodeOption-module__no-pagination___pQrY_ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Icd10CodeOption-module__medical-table-new___yCO_v.Icd10CodeOption-module__no-pagination___pQrY_:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Icd10CodeOption-module__medical-table-new___yCO_v.Icd10CodeOption-module__no-pagination___pQrY_::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Icd10CodeOption-module__medical-table-new___yCO_v.Icd10CodeOption-module__no-pagination___pQrY_::-webkit-scrollbar-track {
  display: none;
}

.Icd10CodeOption-module__medical-table-empty___N3691 {
  padding: 14px 40px !important;
}

.Icd10CodeOption-module__icon-btn___Tl4Zm {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Icd10CodeOption-module__search-icon___p82Se {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Icd10CodeOption-module__disable-select___pkhBe {
  user-select: none;
}

.Icd10CodeOption-module__break-word___yeA4M {
  word-break: break-word;
}

.Icd10CodeOption-module__popup-clear-btn___wLnAS {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Icd10CodeOption-module__scroll-m-b-20___AhzX1 {
  scroll-margin-bottom: 20px;
}

.Icd10CodeOption-module__container___ZLRCz {
  justify-content: space-between;
}
.Icd10CodeOption-module__container___ZLRCz .Icd10CodeOption-module__description___KauV7 {
  color: #375844;
  margin-right: 10px;
}
.Icd10CodeOption-module__container___ZLRCz .Icd10CodeOption-module__code___YUtvY {
  color: #859989;
}

.Icd10CodeOption-module__title___vBROg {
  color: #859989;
  border-top: 0.5px solid rgba(91, 91, 91, 0.2);
  display: flex;
  flex: 1;
}

.Icd10CodeOption-module__error___N8W1I {
  color: #375844;
  font-style: italic;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/MedicalProblemPopup/Icd10CodeOption/Icd10CodeOption.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,8BAAA;AA8pBF;AA5pBE;EACE,cAAA;EACA,kBAAA;AA8pBJ;AA3pBE;EACE,cAAA;AA6pBJ;;AAzpBA;EACE,cAAA;EACA,6CAAA;EACA,aAAA;EACA,OAAA;AA4pBF;;AAzpBA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AA4pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  justify-content: space-between;\n\n  .description {\n    color: get-color(greenNew, dark);\n    margin-right: 10px;\n  }\n\n  .code {\n    color: get-color(greenNew, medium);\n  }\n}\n\n.title {\n  color: get-color(greenNew, medium);\n  border-top: 0.5px solid rgba(91, 91, 91, 0.2);\n  display: flex;\n  flex: 1;\n}\n\n.error {\n  color: get-color(greenNew, dark);\n  font-style: italic;\n  margin-right: 10px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Icd10CodeOption-module__font-s-10___JUrBD`,
	"fontS12": `Icd10CodeOption-module__font-s-12___bYNL1`,
	"fontS13": `Icd10CodeOption-module__font-s-13___aId89`,
	"fontS14": `Icd10CodeOption-module__font-s-14___BXVri`,
	"fontS15": `Icd10CodeOption-module__font-s-15___R6xzz`,
	"fontS16": `Icd10CodeOption-module__font-s-16___JJB2l`,
	"fontS18": `Icd10CodeOption-module__font-s-18___yCBls`,
	"fontS20": `Icd10CodeOption-module__font-s-20___NIoXI`,
	"fontS22": `Icd10CodeOption-module__font-s-22___tB2o7`,
	"fontS28": `Icd10CodeOption-module__font-s-28___cR6_2`,
	"fontW400": `Icd10CodeOption-module__font-w-400___wmrW0`,
	"fontW500": `Icd10CodeOption-module__font-w-500___s4X4M`,
	"fontW600": `Icd10CodeOption-module__font-w-600____KTA0`,
	"fontW700": `Icd10CodeOption-module__font-w-700___Gu3tH`,
	"p5": `Icd10CodeOption-module__p-5___vlrMI`,
	"p12": `Icd10CodeOption-module__p-12___ajtmu`,
	"p16": `Icd10CodeOption-module__p-16___zO5i_`,
	"p30": `Icd10CodeOption-module__p-30___rFq2_`,
	"pB0": `Icd10CodeOption-module__p-b-0___DpCME`,
	"pB5": `Icd10CodeOption-module__p-b-5___sslRN`,
	"pB10": `Icd10CodeOption-module__p-b-10___MOcb9`,
	"pB12": `Icd10CodeOption-module__p-b-12___rV3XK`,
	"pB16": `Icd10CodeOption-module__p-b-16___Bkzfr`,
	"pB18": `Icd10CodeOption-module__p-b-18___vwDhu`,
	"pB20": `Icd10CodeOption-module__p-b-20___KphsW`,
	"pB25": `Icd10CodeOption-module__p-b-25___GXR_o`,
	"pB30": `Icd10CodeOption-module__p-b-30___C7Hba`,
	"pB50": `Icd10CodeOption-module__p-b-50___jZdPI`,
	"pT0": `Icd10CodeOption-module__p-t-0___Xc3HI`,
	"pT12": `Icd10CodeOption-module__p-t-12___Xoibm`,
	"pT16": `Icd10CodeOption-module__p-t-16___L1CEf`,
	"pT18": `Icd10CodeOption-module__p-t-18___c_4yh`,
	"pT20": `Icd10CodeOption-module__p-t-20___AB2hF`,
	"pT30": `Icd10CodeOption-module__p-t-30___pHPsb`,
	"pT40": `Icd10CodeOption-module__p-t-40___yS528`,
	"pT50": `Icd10CodeOption-module__p-t-50___prrXV`,
	"pL20": `Icd10CodeOption-module__p-l-20___ZZA3N`,
	"pL30": `Icd10CodeOption-module__p-l-30___dCbxe`,
	"pL40": `Icd10CodeOption-module__p-l-40___iZz0B`,
	"pR16": `Icd10CodeOption-module__p-r-16___Wk4WK`,
	"pR20": `Icd10CodeOption-module__p-r-20___igWcj`,
	"pR30": `Icd10CodeOption-module__p-r-30___zFL4E`,
	"pR50": `Icd10CodeOption-module__p-r-50___YvTa6`,
	"pR60": `Icd10CodeOption-module__p-r-60___fvlsn`,
	"mB1": `Icd10CodeOption-module__m-b-1___rIWzy`,
	"mB2": `Icd10CodeOption-module__m-b-2___I6GzI`,
	"mB6": `Icd10CodeOption-module__m-b-6___QBGsC`,
	"mB8": `Icd10CodeOption-module__m-b-8___VpG1D`,
	"mB10": `Icd10CodeOption-module__m-b-10___Le8Md`,
	"mB14": `Icd10CodeOption-module__m-b-14___EUp7X`,
	"mB16": `Icd10CodeOption-module__m-b-16___YAqrA`,
	"mB20": `Icd10CodeOption-module__m-b-20___eb8vG`,
	"mB22": `Icd10CodeOption-module__m-b-22___zkeJR`,
	"mB24": `Icd10CodeOption-module__m-b-24___EhnIQ`,
	"mB30": `Icd10CodeOption-module__m-b-30___cwLEk`,
	"mB32": `Icd10CodeOption-module__m-b-32___sfBJb`,
	"mB40": `Icd10CodeOption-module__m-b-40___WktiP`,
	"mT2": `Icd10CodeOption-module__m-t-2___xAjtF`,
	"mT3": `Icd10CodeOption-module__m-t-3___bGsNR`,
	"mT4": `Icd10CodeOption-module__m-t-4___ML1O7`,
	"mT5": `Icd10CodeOption-module__m-t-5___HimpH`,
	"mT8": `Icd10CodeOption-module__m-t-8___Suteq`,
	"mT10": `Icd10CodeOption-module__m-t-10___ieaEy`,
	"mT15": `Icd10CodeOption-module__m-t-15___KUCul`,
	"mT16": `Icd10CodeOption-module__m-t-16___YqY7g`,
	"mT20": `Icd10CodeOption-module__m-t-20___UdBOW`,
	"mT22": `Icd10CodeOption-module__m-t-22___xwnMz`,
	"mT30": `Icd10CodeOption-module__m-t-30___k45ku`,
	"mT32": `Icd10CodeOption-module__m-t-32___pEYJV`,
	"mLAuto": `Icd10CodeOption-module__m-l-auto___wUUW3`,
	"mL4": `Icd10CodeOption-module__m-l-4___s_a6k`,
	"mL5": `Icd10CodeOption-module__m-l-5___efmOr`,
	"mL6": `Icd10CodeOption-module__m-l-6___r5tOe`,
	"mL8": `Icd10CodeOption-module__m-l-8___j6F0n`,
	"mL10": `Icd10CodeOption-module__m-l-10___lDdz0`,
	"mL16": `Icd10CodeOption-module__m-l-16___xhEdB`,
	"mL20": `Icd10CodeOption-module__m-l-20___zdwlF`,
	"mL24": `Icd10CodeOption-module__m-l-24___UHDgS`,
	"mL30": `Icd10CodeOption-module__m-l-30___xUPNn`,
	"mL35": `Icd10CodeOption-module__m-l-35___i8M1k`,
	"mL40": `Icd10CodeOption-module__m-l-40___Xx4nQ`,
	"mR8": `Icd10CodeOption-module__m-r-8___XekZy`,
	"mR10": `Icd10CodeOption-module__m-r-10___hJnfB`,
	"mR16": `Icd10CodeOption-module__m-r-16___GeG8x`,
	"mR20": `Icd10CodeOption-module__m-r-20___nsAx8`,
	"mR24": `Icd10CodeOption-module__m-r-24___X6dfu`,
	"mR30": `Icd10CodeOption-module__m-r-30___hJyyr`,
	"mR40": `Icd10CodeOption-module__m-r-40___uOD7z`,
	"borderR3": `Icd10CodeOption-module__border-r-3___ljjJM`,
	"borderR4": `Icd10CodeOption-module__border-r-4___nOjrj`,
	"borderR6": `Icd10CodeOption-module__border-r-6___nhBUA`,
	"borderR10": `Icd10CodeOption-module__border-r-10___qFTxf`,
	"borderR12": `Icd10CodeOption-module__border-r-12___ydqKc`,
	"borderR16": `Icd10CodeOption-module__border-r-16___As5Pr`,
	"borderR50": `Icd10CodeOption-module__border-r-50___IKDkf`,
	"primaryBorder": `Icd10CodeOption-module__primary-border___NWuIi`,
	"primaryBorderB": `Icd10CodeOption-module__primary-border-b___PLmHS`,
	"primaryBorderT": `Icd10CodeOption-module__primary-border-t___sFXQf`,
	"primaryBorderL": `Icd10CodeOption-module__primary-border-l___nDGcD`,
	"primaryBorderR": `Icd10CodeOption-module__primary-border-r___MMIix`,
	"secondaryBorder": `Icd10CodeOption-module__secondary-border___ttelz`,
	"secondaryBorderB": `Icd10CodeOption-module__secondary-border-b___bPLs8`,
	"secondaryBorderT": `Icd10CodeOption-module__secondary-border-t___OsskH`,
	"secondaryBorderL": `Icd10CodeOption-module__secondary-border-l___LbMaf`,
	"secondaryBorderR": `Icd10CodeOption-module__secondary-border-r___JImsU`,
	"gap0": `Icd10CodeOption-module__gap-0___J_nX9`,
	"gap2": `Icd10CodeOption-module__gap-2___jwJGL`,
	"gap4": `Icd10CodeOption-module__gap-4___vkpPx`,
	"gap5": `Icd10CodeOption-module__gap-5___F76Wl`,
	"gap6": `Icd10CodeOption-module__gap-6___NZAvm`,
	"gap8": `Icd10CodeOption-module__gap-8___NmqwZ`,
	"gap10": `Icd10CodeOption-module__gap-10___GnzEt`,
	"gap12": `Icd10CodeOption-module__gap-12____RDiV`,
	"gap14": `Icd10CodeOption-module__gap-14___Bmx_M`,
	"gap16": `Icd10CodeOption-module__gap-16___xpiei`,
	"gap18": `Icd10CodeOption-module__gap-18___rDc6J`,
	"gap20": `Icd10CodeOption-module__gap-20___pZ1KU`,
	"gap24": `Icd10CodeOption-module__gap-24___K29GT`,
	"gap26": `Icd10CodeOption-module__gap-26___P3N3n`,
	"gap30": `Icd10CodeOption-module__gap-30___VnK7J`,
	"gap32": `Icd10CodeOption-module__gap-32___pNnUB`,
	"gap40": `Icd10CodeOption-module__gap-40___qDptb`,
	"gap50": `Icd10CodeOption-module__gap-50___qYxbQ`,
	"flex1": `Icd10CodeOption-module__flex-1___hpLR8`,
	"flexNone": `Icd10CodeOption-module__flex-none___mCnoP`,
	"flexColumn": `Icd10CodeOption-module__flex-column___RuZzc`,
	"flexRow": `Icd10CodeOption-module__flex-row___bIrQi`,
	"verticallyCentered": `Icd10CodeOption-module__vertically-centered___KvdV3`,
	"horizontallyCentered": `Icd10CodeOption-module__horizontally-centered___o8rfk`,
	"horizontallyEnd": `Icd10CodeOption-module__horizontally-end___YDHHJ`,
	"verticallyStart": `Icd10CodeOption-module__vertically-start___enxeL`,
	"spaceBetween": `Icd10CodeOption-module__space-between___i8Jto`,
	"flexWrap": `Icd10CodeOption-module__flex-wrap___RB9H7`,
	"height100": `Icd10CodeOption-module__height-100___conIS`,
	"width50": `Icd10CodeOption-module__width-50___gveZR`,
	"width100": `Icd10CodeOption-module__width-100___L4zbS`,
	"cursorPointer": `Icd10CodeOption-module__cursor-pointer___sTS81`,
	"cursorNotAllowed": `Icd10CodeOption-module__cursor-not-allowed___IioSS`,
	"absoluteCentered": `Icd10CodeOption-module__absolute-centered___vO_qg`,
	"absolute": `Icd10CodeOption-module__absolute___mRpcQ`,
	"relative": `Icd10CodeOption-module__relative___Z2do3`,
	"fixed": `Icd10CodeOption-module__fixed___levTj`,
	"visible": `Icd10CodeOption-module__visible___mCR8O`,
	"invisible": `Icd10CodeOption-module__invisible___v3iQj`,
	"col90": `Icd10CodeOption-module__col-90___HINB9`,
	"colAuto": `Icd10CodeOption-module__col-auto___uG_nM`,
	"medicalTabs": `Icd10CodeOption-module__medical-tabs___GTm8L`,
	"medicalTableNew": `Icd10CodeOption-module__medical-table-new___yCO_v`,
	"noPagination": `Icd10CodeOption-module__no-pagination___pQrY_`,
	"medicalTableEmpty": `Icd10CodeOption-module__medical-table-empty___N3691`,
	"iconBtn": `Icd10CodeOption-module__icon-btn___Tl4Zm`,
	"searchIcon": `Icd10CodeOption-module__search-icon___p82Se`,
	"disableSelect": `Icd10CodeOption-module__disable-select___pkhBe`,
	"breakWord": `Icd10CodeOption-module__break-word___yeA4M`,
	"popupClearBtn": `Icd10CodeOption-module__popup-clear-btn___wLnAS`,
	"scrollMB20": `Icd10CodeOption-module__scroll-m-b-20___AhzX1`,
	"container": `Icd10CodeOption-module__container___ZLRCz`,
	"description": `Icd10CodeOption-module__description___KauV7`,
	"code": `Icd10CodeOption-module__code___YUtvY`,
	"title": `Icd10CodeOption-module__title___vBROg`,
	"error": `Icd10CodeOption-module__error___N8W1I`
};
module.exports = ___CSS_LOADER_EXPORT___;
